import "./Home.module.css";
import KurumsalKimlikBasligi from "@/reusable_sections/Header";
import HukukiRehberlikVeDanismanlik from "./sections/HukukiRehberlikVeDanismanlik";
import HukukiUzmanlikAlanlari from "./sections/HukukiUzmanlikAlanlari";
import UzmanArabuluculukHizmetleri from "./sections/UzmanArabuluculukHizmetleri";
import CorporatePrinciplesAndEthicalValues from "./sections/CorporatePrinciplesAndEthicalValues";
import LegalArticlesAndUpdates from "./sections/LegalArticlesAndUpdates";
import LegalConsultationContact from "./sections/LegalConsultationContact";
import KurumsalAltBilgi from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <KurumsalKimlikBasligi />
      <HukukiRehberlikVeDanismanlik />
      <HukukiUzmanlikAlanlari />
      <UzmanArabuluculukHizmetleri />
      <CorporatePrinciplesAndEthicalValues />
      <LegalArticlesAndUpdates />
      <LegalConsultationContact />
      <KurumsalAltBilgi />
    </div>;
}